import axios from 'axios';
import React, { useEffect, useState } from 'react';
import AdminLayout from '../../Componets/AdminLayout'; // Corrected path
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import Changepassword from '../../Componets/ChangePassword';

export default function ListSubject() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const user = localStorage.getItem('name');
  const role = localStorage.getItem('role');

  const [marksDifferent, setMarksDifferent] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [loaded2, setLoaded2] = useState(false);
  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [selectedMethod, setSelectedMethod] = useState('methodA');
  const [cameraSetting, setCameraSetting] = useState(false);
  const [locationEnabled, setLocationEnabled] = useState(false);
  const [timeValue, setTimeValue] = useState('00:00');

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords();
  }, []);

  // Convert MM:SS time to seconds (e.g., "62:10" → 3730)
  const timeToSeconds = (timeString) => {
    const [minutes, seconds] = timeString.split(':').map(Number);
    return minutes * 60 + seconds;
  };

  // Convert seconds to MM:SS time (e.g., 3730 → "62:10")
  const secondsToTime = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds
      .toString()
      .padStart(2, '0')}`;
  };

  const fetchRecords = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${apiUrl}/api/setting/list`, {
        headers: { Authorization: token },
      });

      setMarksDifferent(response.data.marks_different);
      setSelectedMethod(
        response.data.otpVerifaction === 'SMS' ? 'methodB' : 'methodA'
      );
      setIsSwitchOn(response.data.isTwoFactorAuthentication);
      setCameraSetting(response.data.cameraSetting || false);
      setLocationEnabled(response.data.locationEnabled || false);

      if (response.data.timeInSeconds) {
        setTimeValue(secondsToTime(response.data.timeInSeconds));
      }
    } catch (error) {
      toast.error(error.response?.data?.message);
      error.response?.status === 401 && navigate('/');
    }
  };

  const handleGeneralSettingsSubmit = async (e) => {
    e.preventDefault();
    setLoaded(true);
    const token = localStorage.getItem('token');

    try {
      // Save general settings
      await axios.post(
        `${apiUrl}/api/setting`,
        {
          marks_different: parseInt(marksDifferent),
          cameraSetting,
          timeInSeconds: timeToSeconds(timeValue),
          locationEnabled,
        },
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );

      toast.success('General settings updated successfully!');
      fetchRecords();
    } catch (error) {
      toast.error(error.response?.data?.message);
      error.response?.status === 401 && navigate('/');
    } finally {
      setLoaded(false);
    }
  };

  const handleOTPSettingsSubmit = async (e) => {
    e.preventDefault();
    setLoaded2(true);
    const token = localStorage.getItem('token');

    const twoFactorAuthentication = isSwitchOn;
    const otpType = selectedMethod === 'methodA' ? 'Email' : 'SMS';

    try {
      await axios.post(
        `${apiUrl}/api/setting/authentication`,
        {
          twoFactorAuthentication,
          otpType,
        },
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );

      toast.success('OTP settings updated successfully!');
      setLoaded2(false);
      fetchRecords();
    } catch (error) {
      toast.error(error.response?.data?.message);
      error.response?.status === 401 && navigate('/');
    } finally {
      setLoaded2(false);
    }
  };

  // Custom time input handler for MM:SS format
  const handleTimeChange = (e) => {
    const value = e.target.value;
    // Allow only digits and colon, and ensure proper MM:SS format
    if (/^[0-9:]*$/.test(value) && value.length <= 5) {
      // Auto-insert colon after 2 digits
      if (value.length === 2 && !value.includes(':')) {
        setTimeValue(value + ':');
      } else {
        setTimeValue(value);
      }
    }
  };

  // Format time on blur
  const handleTimeBlur = () => {
    let [minutes, seconds] = timeValue.split(':');

    // Handle cases where input might be incomplete
    if (!seconds) seconds = '00';
    if (!minutes) minutes = '00';

    // Pad with zeros if needed
    minutes = minutes.padStart(2, '0');
    seconds = seconds.padStart(2, '0');

    // Ensure seconds don't exceed 59
    if (parseInt(seconds) > 59) {
      seconds = '59';
    }

    setTimeValue(`${minutes}:${seconds}`);
  };

  return (
    <AdminLayout ac1="active">
      <main id="main" className="main">
        <div className="pagetitle">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/AdminHome">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Admin Setting</li>
            </ol>
          </nav>
        </div>
        <hr className="mb-0" />
        <section className="section profile mt-3">
          <div className="row">
            <div className="col-xl-4">
              <div className="card">
                <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
                  <img
                    src="assets/img/profile-img.png"
                    alt="Profile"
                    className="rounded-circle"
                  />
                  <h2>{user}</h2>
                  <h3>{role}</h3>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="card">
                <div className="card-body p-3 pb-0">
                  <ul className="nav nav-tabs nav-tabs-bordered" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        data-bs-toggle="tab"
                        data-bs-target="#profile-overview"
                        aria-selected="true"
                        role="tab"
                      >
                        Setting
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        data-bs-toggle="tab"
                        data-bs-target="#change-password"
                        aria-selected="false"
                        role="tab"
                      >
                        Change Password
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content pt-2">
                    <div
                      className="tab-pane fade show active profile-overview"
                      id="profile-overview"
                      role="tabpanel"
                    >
                      <div className="row">
                        <div className="col-lg-12">
                          <form onSubmit={handleGeneralSettingsSubmit}>
                            <div className="row mb-3 align-items-center">
                              <label
                                htmlFor="marksDifferent"
                                className="col-sm-4 col-form-label"
                              >
                                Two Faculty Marks Difference
                              </label>
                              <div className="col-sm-2">
                                <input
                                  id="marksDifferent"
                                  type="number"
                                  value={marksDifferent}
                                  onChange={(e) =>
                                    setMarksDifferent(parseInt(e.target.value))
                                  }
                                  className="form-control"
                                  onWheel={(e) => e.target.blur()}
                                  min={0}
                                />
                              </div>
                            </div>
                            <div className="row mb-3 align-items-center">
                              <label className="col-sm-4 col-form-label">
                                Camera Access
                              </label>
                              <div className="col-sm-4">
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={cameraSetting}
                                    onChange={(e) =>
                                      setCameraSetting(e.target.checked)
                                    }
                                    id="cameraSettingSwitch"
                                    style={{ height: '24px', width: '55px' }}
                                  />
                                  <label
                                    className="form-check-label ms-2"
                                    htmlFor="cameraSettingSwitch"
                                  >
                                    {cameraSetting ? 'Enabled' : 'Disabled'}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3 align-items-center">
                              <label
                                htmlFor="timeInput"
                                className="col-sm-4 col-form-label"
                              >
                                Paper Checking Time Limit (MM:SS)
                              </label>
                              <div className="col-sm-3">
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    id="timeInput"
                                    className="form-control"
                                    value={timeValue}
                                    onChange={handleTimeChange}
                                    onBlur={handleTimeBlur}
                                    placeholder="MM:SS"
                                    maxLength="5"
                                  />
                                  <div className="position-absolute top-50 end-0 translate-middle-y pe-3 pointer-events-none">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-clock text-secondary"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M8 3.5a.5.5 0 0 1 .5.5v4.25l3.5 2.1a.5.5 0 0 1-.5.85l-4-2.4A.5.5 0 0 1 7.5 8V4a.5.5 0 0 1 .5-.5z" />
                                      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1A7 7 0 1 1 8 1a7 7 0 0 1 0 14z" />
                                    </svg>
                                  </div>
                                </div>
                                <small className="text-muted">
                                  Total: {timeToSeconds(timeValue)} seconds
                                </small>
                              </div>
                            </div>
                            <div className="row mb-3 align-items-center">
                              <label className="col-sm-4 col-form-label">
                                Location Access
                              </label>
                              <div className="col-sm-4">
                                <div className="form-check form-switch">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    checked={locationEnabled}
                                    onChange={(e) =>
                                      setLocationEnabled(e.target.checked)
                                    }
                                    id="locationEnabledSwitch"
                                    style={{ height: '24px', width: '55px' }}
                                  />
                                  <label
                                    className="form-check-label ms-2"
                                    htmlFor="locationEnabledSwitch"
                                  >
                                    {locationEnabled ? 'Enabled' : 'Disabled'}
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-sm-12 text-end">
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-sm mt-1"
                                  disabled={loaded}
                                >
                                  {loaded ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>{' '}
                                      Wait...
                                    </>
                                  ) : (
                                    <>Save</>
                                  )}
                                </button>
                              </div>
                            </div>
                          </form>
                          <hr className="mb-2" />

                          <div className="row">
                            <div className="col-4">
                              <label className="col-form-label">
                                Two-Factor Authentication
                              </label>
                            </div>
                            <div className="col-1">
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={isSwitchOn}
                                  onChange={(e) =>
                                    setIsSwitchOn(e.target.checked)
                                  }
                                  style={{ height: '24px', width: '55px' }}
                                />
                              </div>
                            </div>
                            <div className="col mt-1 mx-2">
                              {isSwitchOn && (
                                <div className="flex flex-row d-flex">
                                  <div className="form-check mx-1">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="method"
                                      id="methodA"
                                      value="methodA"
                                      checked={selectedMethod === 'methodA'}
                                      onChange={() =>
                                        setSelectedMethod('methodA')
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="methodA"
                                    >
                                      Email
                                    </label>
                                  </div>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="method"
                                      id="methodB"
                                      value="methodB"
                                      checked={selectedMethod === 'methodB'}
                                      onChange={() =>
                                        setSelectedMethod('methodB')
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="methodB"
                                    >
                                      SMS
                                    </label>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-3">
                              <div className="text-end">
                                <button
                                  onClick={handleOTPSettingsSubmit}
                                  className="btn btn-primary btn-sm mt-1"
                                  disabled={loaded2}
                                >
                                  {loaded2 ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>{' '}
                                      Wait...
                                    </>
                                  ) : (
                                    <>save</>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      className="tab-pane fade"
                      id="change-password"
                      role="tabpanel"
                    >
                      <div className="row">
                        <div className="col-lg-12">
                          <Changepassword />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <ToastContainer position="top-center" style={{ width: 'auto' }} />
      </main>
    </AdminLayout>
  );
}
